<div class="rek-framed-portlet">
  <div class="rek-framed-portlet__title">
    <h5>{{ title }}</h5>
  </div>

  <div class="row">
    <div class="col">
      <div class="rek-framed-portlet-portlet kt-portlet kt-portlet-shadow">
        <div class="kt-portlet__body">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>